var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "27px",
        height: "26px",
        viewBox: "0 0 27 26",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("title", [_vm._v("Twitter")]),
      _vm._v(" "),
      _c("defs", [
        _c("path", {
          attrs: {
            d: "M12.913532,2.03924603 L12.8844256,2.01895503 C12.2828937,1.42037037 11.5746384,1.1362963 10.7596597,1.17687831 L10.7305533,1.11600529 L10.7499575,1.10585979 C11.4873192,0.933386243 11.923915,0.750767196 12.0597448,0.547857143 C12.0985533,0.385529101 12.0500426,0.294219577 11.8851065,0.273928571 C11.5164256,0.324656085 11.167149,0.405820106 10.8663831,0.53771164 C11.2544682,0.273928571 11.4000001,0.0913095238 11.3126809,0 C10.934298,0.0101455026 10.5171065,0.213055556 10.0902128,0.618875661 C10.2454469,0.334801587 10.3133618,0.172473545 10.2745533,0.15218254 C10.0611065,0.294219577 9.88646816,0.456547619 9.73123412,0.629021164 C9.40136177,1.01455026 9.13940433,1.36964286 8.93565964,1.69429894 L8.92595752,1.71458995 C8.41174475,2.59724868 8.04306389,3.47990741 7.82961708,4.38285714 L7.75200006,4.45387566 L7.7325958,4.46402116 C7.42212772,4.05820106 7.04374473,3.71325397 6.59744686,3.4393254 C6.07353196,3.0740873 5.45259579,2.73928571 4.73463833,2.40448413 C3.95846812,1.97837302 3.16289364,1.63342593 2.36731917,1.35949735 C2.35761704,2.3030291 2.80391492,3.04365079 3.66740428,3.59150794 L3.66740428,3.60165344 C3.36663832,3.60165344 3.06587236,3.65238095 2.77480853,3.74369048 C2.8330213,4.6162037 3.42485109,5.21478836 4.54059578,5.53944444 L4.53089365,5.55973545 C4.0942979,5.52929894 3.73531918,5.69162698 3.45395747,6.02642857 C3.82263833,6.77719577 4.47268089,7.13228836 5.41378728,7.11199735 C5.22944685,7.21345238 5.08391493,7.31490741 4.98689366,7.43665344 C4.81225536,7.62941799 4.75404259,7.85261905 4.81225536,8.10625661 C5.01600004,8.49178571 5.37497876,8.66425926 5.90859579,8.63382275 L5.93770217,8.67440476 L5.92800005,8.69469577 C5.00629791,9.68895503 3.89055322,10.1353571 2.5904681,10.0440476 L2.57106385,10.0541931 C1.77548938,10.0440476 0.921702135,9.64837302 0,8.85702381 C0.921702135,10.2469577 2.15387236,11.2513624 3.67710641,11.8905291 C5.41378728,12.4891138 7.16017027,12.5398413 8.89685113,12.0224206 L8.92595752,12.0224206 C10.6141277,11.5151455 12.0403405,10.4600132 13.2240001,8.87731481 C13.7673193,8.0555291 14.1068937,7.26417989 14.2427235,6.5032672 C15.1256171,6.5337037 15.7562554,6.26992063 16.1540427,5.70177249 L16.1443405,5.68148148 C15.8435746,5.79308201 15.2711491,5.7626455 14.4270639,5.58002646 L14.4270639,5.47857143 C15.3584682,5.3669709 15.9114895,5.05246032 16.0861278,4.53503968 C15.4360852,4.79882275 14.7957448,4.80896825 14.1651065,4.55533069 C14.048681,3.64223545 13.6314895,2.80015873 12.913532,2.03924603",
            id: "path-1",
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-Layouts",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            opacity: "0.1976609",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Profile-EMPTY",
                transform: "translate(-330.000000, -565.000000)",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Intro-Block",
                    transform: "translate(220.000000, 298.000000)",
                  },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Social-Links-GRAYED-OUT",
                        transform: "translate(40.000000, 267.000000)",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "t",
                            transform: "translate(70.850000, 0.000000)",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: {
                              id: "Oval",
                              fill: "#000000",
                              cx: "13",
                              cy: "13",
                              r: "13",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "icon",
                                transform: "translate(5.257840, 7.085442)",
                              },
                            },
                            [
                              _c(
                                "mask",
                                { attrs: { id: "mask-2", fill: "white" } },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#path-1" },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("use", {
                                attrs: {
                                  id: "Mask",
                                  fill: "#FFFFFF",
                                  "xlink:href": "#path-1",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }